import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { NewRelicService } from './app/data-access/shared/services/newrelic.service';
import environment from './environments/environment';

/***
 * Logging user out from
 * all the tabs in session.
 */
window.addEventListener('storage', (event: StorageEvent) => {
  if (event.storageArea === localStorage) {
    if (event.key === 'user-custom-session' && event.newValue === null) {
      window.location.href = '/login';
      window.location.reload();
    }
    if (event.key === 'is-impersonating' && event.newValue === null) {
      window.location.href = '/profiles/people/home';
    }
    if (event.key === 'is-impersonating' && event.newValue === 'true') {
      window.location.href = '/welcome';
    }
  }
});

platformBrowser()
  .bootstrapModule(AppModule)
  .then((moduleRef) => {
    if (environment.newRelic?.enabled) {
      setTimeout(() => {
        moduleRef.injector.get(NewRelicService).init();
      }, 100);
    }
  })
  .catch((err) => console.error(err));
